export default __webpack_public_path__ + "static/media/jpeg-jpg-icon-map-clicked.01ddb91d.svg";